import * as React from 'react';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import styles from './DetailsModal.styl';
import classnames from 'classnames';
const DetailsModal = ({ content, icon, contentClassName }) => {
    const contentClasses = classnames(styles.modalText, contentClassName, { [styles.modalOptionText]: icon });
    return (React.createElement("div", { className: styles.modalWrapper }, content.map((item, index) => (React.createElement("span", { className: contentClasses, key: index },
        icon && React.createElement(IconSVG, { className: styles.doneIcon, name: 'doubleDone' }),
        item)))));
};
export default DetailsModal;
